import { render, staticRenderFns } from "./BaseTimesIcon.vue?vue&type=template&id=084743b4"
import script from "./BaseTimesIcon.vue?vue&type=script&lang=js"
export * from "./BaseTimesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports